module.exports = __webpack_public_path__ + "img/GREEN_TREE.9d622598.png";